/* Heartwip Custom JavaScript - Mobile First */

(function() {
  'use strict';

  console.log('Heartwip Custom JS: Loading...');

  /* ========================================
     LOGO SWAP ON MENU OPEN
     ======================================== */

  function initLogoSwap() {
    var headerLogo = document.querySelector('.header__logo');
    var menuStarLogoUrl = 'https://cdn.shopify.com/s/files/1/0811/3196/2618/files/heart-final.svg?v=1770207960';

    if (!headerLogo) {
      console.log('Heartwip: Logo element not found');
      return;
    }

    var menuLogo = document.createElement('img');
    menuLogo.src = menuStarLogoUrl;
    menuLogo.alt = 'Heartwip Star Logo';
    menuLogo.className = 'header__logo-image header__logo-image--menu';
    menuLogo.style.cssText = 'display: none; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 40px; height: auto; z-index: 10;';

    var logoLink = headerLogo.querySelector('a');
    if (logoLink) {
      logoLink.style.position = 'relative';
      logoLink.appendChild(menuLogo);
    }

    var header = document.querySelector('.header');
    if (header) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'class') {
            var isMenuOpen = header.classList.contains('menu-open');
            var mainLogos = headerLogo.querySelectorAll('.header__logo-image:not(.header__logo-image--menu):not(.header__logo-image-transparent)');

            if (isMenuOpen) {
              mainLogos.forEach(function(logo) {
                logo.style.opacity = '0';
                logo.style.visibility = 'hidden';
              });
              menuLogo.style.display = 'block';
            } else {
              mainLogos.forEach(function(logo) {
                logo.style.opacity = '1';
                logo.style.visibility = 'visible';
              });
              menuLogo.style.display = 'none';
            }
          }
        });
      });

      observer.observe(header, { attributes: true });
      console.log('Heartwip: Logo swap initialized');
    }
  }

  /* ========================================
     HERO COVER EFFECT
     When scrolling, content slides over the hero
     The hero stays fixed, content scrolls over it
     ======================================== */

  function initHeroCoverEffect() {
    var mainContent = document.getElementById('MainContent');
    if (!mainContent) {
      mainContent = document.querySelector('main');
    }
    if (!mainContent) {
      console.log('Heartwip: Main content not found');
      return;
    }

    // Get direct child sections
    var allSections = mainContent.querySelectorAll(':scope > .shopify-section');
    if (!allSections || allSections.length < 2) {
      console.log('Heartwip: Not enough sections for cover effect');
      return;
    }

    console.log('Heartwip: Found ' + allSections.length + ' sections in main');

    // First section is hero - make it sticky
    var heroSection = allSections[0];
    if (!heroSection) return;

    // Get header height for offset
    var headerGroup = document.querySelector('.shopify-section-group-header-group');
    var headerHeight = headerGroup ? headerGroup.offsetHeight : 0;

    // Make hero sticky using setAttribute for reliability
    heroSection.setAttribute('style', 'position: sticky !important; top: ' + headerHeight + 'px !important; z-index: 1 !important;');
    console.log('Heartwip: Hero section made sticky with top: ' + headerHeight + 'px');

    // Make all following sections cover the hero with higher z-index
    for (var i = 1; i < allSections.length; i++) {
      var section = allSections[i];

      // Get existing background or set white
      var computedBg = window.getComputedStyle(section).backgroundColor;
      var bgColor = '#ffffff';
      if (computedBg && computedBg !== 'rgba(0, 0, 0, 0)' && computedBg !== 'transparent') {
        bgColor = computedBg;
      }

      section.setAttribute('style', 'position: relative !important; z-index: ' + (i + 10) + ' !important; background-color: ' + bgColor + ' !important;');
    }

    // Also handle footer
    var footerElement = document.querySelector('footer');
    if (footerElement) {
      footerElement.setAttribute('style', 'position: relative !important; z-index: 100 !important; background-color: #ffffff !important;');
    }

    var footerGroup = document.querySelector('.shopify-section-group-footer-group');
    if (footerGroup) {
      footerGroup.setAttribute('style', 'position: relative !important; z-index: 100 !important;');
    }

    console.log('Heartwip: Cover effect initialized');
  }

  /* ========================================
     SCROLL REVEAL ANIMATIONS
     ======================================== */

  function initScrollReveal() {
    // Get main content area
    var mainContent = document.getElementById('MainContent');
    if (!mainContent) {
      mainContent = document.querySelector('main');
    }
    if (!mainContent) return;

    // Get all shopify sections inside main
    var allSections = mainContent.querySelectorAll(':scope > .shopify-section');
    if (!allSections || allSections.length === 0) return;

    // Convert to array and filter
    var sectionsArray = Array.prototype.slice.call(allSections);

    // Skip the first section (hero) and any announcement bars
    var sectionsToAnimate = sectionsArray.filter(function(section, index) {
      // Skip first section (hero)
      if (index === 0) return false;
      // Skip announcement bars
      if (section.className.indexOf('announcement') > -1) return false;
      return true;
    });

    console.log('Heartwip: ' + sectionsToAnimate.length + ' sections to animate');

    // Apply hidden state to sections below viewport
    sectionsToAnimate.forEach(function(section) {
      var rect = section.getBoundingClientRect();
      // Only animate sections that start below 50% of viewport
      if (rect.top > window.innerHeight * 0.5) {
        // Preserve existing styles and add animation styles
        var existingStyle = section.getAttribute('style') || '';
        section.setAttribute('style', existingStyle + ' opacity: 0 !important; transform: translateY(60px) !important; transition: opacity 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;');
        section.dataset.hwReveal = 'pending';
      }
    });

    // Create observer for reveal
    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && entry.target.dataset.hwReveal === 'pending') {
            // Update styles to reveal
            var existingStyle = entry.target.getAttribute('style') || '';
            // Replace opacity and transform values
            existingStyle = existingStyle.replace(/opacity:\s*0\s*!important;?/gi, 'opacity: 1 !important;');
            existingStyle = existingStyle.replace(/transform:\s*translateY\([^)]+\)\s*!important;?/gi, 'transform: translateY(0) !important;');
            entry.target.setAttribute('style', existingStyle);
            entry.target.dataset.hwReveal = 'done';
            revealObserver.unobserve(entry.target);
            console.log('Heartwip: Revealed section');
          }
        });
      }, {
        root: null,
        rootMargin: '0px 0px -50px 0px',
        threshold: 0.05
      });

      // Observe pending sections
      sectionsToAnimate.forEach(function(section) {
        if (section.dataset.hwReveal === 'pending') {
          revealObserver.observe(section);
        }
      });

      console.log('Heartwip: Scroll reveal initialized');
    }
  }

  /* ========================================
     ENSURE HEADER STAYS STICKY AND ON TOP
     (Only header, NOT announcement bar)
     ======================================== */

  function fixHeaderSticky() {
    // Only target the header section - NOT the announcement bar
    var headerSection = document.querySelector('.section-header');
    var announcementBar = document.querySelector('.section-announcement-bar');

    // Make specific announcement bar sticky at top 30px (only homepage one)
    var specificAnnouncementBar = document.getElementById('shopify-section-sections--22692285776122__announcement-bar');
    if (specificAnnouncementBar) {
      specificAnnouncementBar.setAttribute('style', 'position: -webkit-sticky !important; position: sticky !important; top: 30px !important; z-index: 999 !important; width: 100% !important;');
      console.log('Heartwip: Specific announcement bar set to sticky at top 30px');
    }

    // Make header sticky at top 22px
    if (headerSection) {
      headerSection.setAttribute('style', 'position: -webkit-sticky !important; position: sticky !important; top: 22px !important; z-index: 1000 !important; width: 100% !important;');
      console.log('Heartwip: Header section made sticky');
    }
  }

  /* ========================================
     PRODUCT CARD IMAGE GALLERY NAVIGATION
     ======================================== */

  function initProductCardGallery() {
    // Find all product card media containers that haven't been initialized
    var galleries = document.querySelectorAll('[data-product-media-gallery]:not([data-gallery-initialized])');

    galleries.forEach(function(gallery) {
      // Mark as initialized to prevent duplicate handlers
      gallery.setAttribute('data-gallery-initialized', 'true');

      // Find all product images (exclude hover images initially)
      var mainImages = gallery.querySelectorAll('img:not(.hover-img)');
      var hoverImage = gallery.querySelector('img.hover-img');
      var prevBtn = gallery.querySelector('[data-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-gallery-next]');

      // Build the images array - include hover image if we only have 1 main image
      var images = [];
      mainImages.forEach(function(img) {
        images.push(img);
      });

      // If only 1 main image but there's a hover image, include the hover image for navigation
      if (mainImages.length === 1 && hoverImage) {
        images.push(hoverImage);
        console.log('Heartwip Gallery: Including hover image in navigation');
      }

      console.log('Heartwip Gallery: Found ' + images.length + ' navigable images, prev: ' + !!prevBtn + ', next: ' + !!nextBtn);

      // If no navigation buttons, skip (Liquid didn't render them because media.size <= 1)
      if (!prevBtn || !nextBtn) {
        console.log('Heartwip Gallery: No nav buttons found, skipping');
        return;
      }

      // If only one image total, mark as single and hide arrows
      if (images.length <= 1) {
        gallery.setAttribute('data-single-image', 'true');
        console.log('Heartwip Gallery: Single image, hiding arrows');
        return;
      }

      // Remove single-image attribute if it was set
      gallery.removeAttribute('data-single-image');

      var currentIndex = 0;
      var hasHoverInRotation = (mainImages.length === 1 && hoverImage);

      // Find which image is currently visible (not hidden)
      images.forEach(function(img, index) {
        if (!img.classList.contains('hidden') && !img.classList.contains('hover-img')) {
          currentIndex = index;
        }
      });

      function showImage(index) {
        images.forEach(function(img, i) {
          if (i === index) {
            img.classList.remove('hidden');
            img.style.display = '';
            img.style.opacity = '1';
            img.style.visibility = 'visible';
            // If showing hover image as main, remove hover-img behavior temporarily
            if (img.classList.contains('hover-img')) {
              img.style.position = 'relative';
              img.style.zIndex = '1';
            }
          } else {
            img.classList.add('hidden');
            // Reset hover image if hiding it
            if (img.classList.contains('hover-img')) {
              img.style.position = '';
              img.style.zIndex = '';
            }
          }
        });
        currentIndex = index;
        console.log('Heartwip Gallery: Showing image ' + (index + 1) + ' of ' + images.length);
      }

      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var newIndex = currentIndex - 1;
        if (newIndex < 0) newIndex = images.length - 1;
        showImage(newIndex);
        return false;
      });

      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var newIndex = currentIndex + 1;
        if (newIndex >= images.length) newIndex = 0;
        showImage(newIndex);
        return false;
      });

      console.log('Heartwip Gallery: Initialized with ' + images.length + ' images' + (hasHoverInRotation ? ' (including hover)' : ''));
    });

    if (galleries.length > 0) {
      console.log('Heartwip: Product card gallery initialized for ' + galleries.length + ' new cards');
    }
  }

  // Re-initialize galleries when content changes (for infinite scroll, filtering, etc.)
  function observeForNewGalleries() {
    if ('MutationObserver' in window) {
      var galleryObserver = new MutationObserver(function(mutations) {
        var shouldInit = false;
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1) {
                if (node.hasAttribute && node.hasAttribute('data-product-media-gallery')) {
                  shouldInit = true;
                } else if (node.querySelector && node.querySelector('[data-product-media-gallery]:not([data-gallery-initialized])')) {
                  shouldInit = true;
                }
              }
            });
          }
        });
        if (shouldInit) {
          setTimeout(initProductCardGallery, 100);
        }
      });

      galleryObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  /* ========================================
     INITIALIZE
     ======================================== */

  function init() {
    console.log('Heartwip Custom JS: Initializing...');
    try {
      fixHeaderSticky();
      initLogoSwap();
      initProductCardGallery();
      observeForNewGalleries();
      // Disabled: Hero cover effect and scroll reveal
      // initHeroCoverEffect();
      // initScrollReveal();
      console.log('Heartwip Custom JS: All initialized successfully');
    } catch (e) {
      console.error('Heartwip JS Error:', e);
    }
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM already loaded
    init();
  }

})();
